export default {
    SERVER_BASE_URL: 'https://api.welearn.wemlo.io/',
    PHONE_EXT:'+1',
    ENV: 'production',
    CLIENT_URL:'https://app.welearn.wemlo.io/',
    OPTIMIZELY_KEY: '3MGaqGg3JCKmmZGc6qLdo',
}
